
import { CommandResult, UserNotification } from '../amorg-common'
import { apiPath } from "./../amorg-common";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

const userNotificationsPath = `${apiPath}/usernotifications`;

export const getUserNotifications = async (userId:string, includeInactive:boolean, includeIgnored:boolean): Promise<UserNotification[]> =>
    queryAuthWrapper(`${userNotificationsPath}/${userId}/?includeInactive=${includeInactive===true}&includeIgnored=${includeIgnored===true}`);

export const updateUserNotification = async (notificationId:string, userId:string, ignore:boolean): Promise<CommandResult> =>
    commandAuthWrapper(`${userNotificationsPath}/${userId}`, 'PUT',
    {
        notificationId,
        ignore
    });